import { createApp } from "vue";
import App from "./App.vue";

const postwurfspezialApp = createApp(App);
window.postwurfspezialApp = postwurfspezialApp;
